module.exports = __webpack_public_path__ + "img/IconMail.eb635bdd.svg";